import store from "@src/reducers/store";
import { updateShowRenderUnreleasedFeaturesStyle } from "@src/reducers/your-reducer";

export const toggleUnreleasedFeaturesBorder = () => {
  const showRenderUnreleasedFeaturesStyle =
    store.getState().yourSlice.showRenderUnreleasedFeaturesStyle;

  store.dispatch(
    updateShowRenderUnreleasedFeaturesStyle(!showRenderUnreleasedFeaturesStyle),
  );
};
